import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/lists'
import Component from 'components/Lists'

export default createListViewContainer({ actions, selectors: selectors.lists })(Component)
